export default {
  unlockActivity: 'ua',
  unlockSuccess: 'us',
  unlockFailure: 'uf',
};
